(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const motionEnabled = () => window.SevenFortyFive.motion.enabled();
  const targets = [];
  let toneFrame = null, toneUntil = 0;
  function refreshTone(time) {
    document.dispatchEvent(new Event('745:motion'));
    toneFrame = time < toneUntil && !document.hidden ? requestAnimationFrame(refreshTone) : null;
  }
  function trackEntrance(delay) {
    if (!motionEnabled()) {document.dispatchEvent(new Event('745:motion')); return;}
    toneUntil = Math.max(toneUntil,performance.now()+1250+delay);
    if (toneFrame === null) toneFrame=requestAnimationFrame(refreshTone);
  }
  function enter(el,kind='motion-enter',delay=0) {
    if (!el) return;
    el.classList.add(kind);
    if (delay) el.style.setProperty('--entry-delay',delay+'ms');
    targets.push(el);
  }
  // Reveal images through fixed masks without changing their framing.
  document.querySelectorAll('.card-image,.gallery-image,.print-image').forEach(mask => {
    const layer = document.createElement('div');
    layer.className = 'image-motion';
    Array.from(mask.children).forEach(child => layer.append(child));
    mask.append(layer);
    enter(mask,'motion-image');
  });
  enter(document.querySelector('.hero-products'));
  document.querySelectorAll('.hero-copy h1,.hero-copy p').forEach(el=>enter(el));
  document.querySelectorAll('.section-heading,.print-copy h2,.more-products>h2,.about-label,.about-positioning').forEach(el=>enter(el));
  document.querySelectorAll('.card-caption,.print-copy p').forEach(el=>enter(el,'motion-enter',150));
  document.querySelectorAll('.product-info>.product-drop,.product-info>h1,.product-info>.product-description,.product-info>.buy-panel,.product-info>.donation-note').forEach((el,i)=>enter(el,'motion-enter',Math.min(i*100,300)));
  document.querySelectorAll('.about-intro p').forEach((el,i)=>enter(el,'motion-enter',150+i*120));
  document.querySelectorAll('.about-section h2,.about-section p,.about-actions').forEach(el=>enter(el,'motion-enter',150));
  document.querySelectorAll('.gavin-film video').forEach(el=>enter(el,'motion-film'));
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) reveal(entry.target);
  }),{threshold:.08});
  function reveal(el,immediate=false) {
    if (immediate) {
      el.style.transition = 'none';
      el.style.setProperty('--entry-delay','0ms');
      const layer=el.querySelector('.image-motion');
      if (layer) layer.style.transition='none';
    }
    if (!el.classList.contains('is-visible')) trackEntrance(parseFloat(el.style.getPropertyValue('--entry-delay')) || 0);
    el.classList.add('is-visible');
    observer.unobserve(el);
  }
  function revealAll() {if (!motionEnabled()) targets.forEach(el=>reveal(el,true));}
  targets.forEach(el=>observer.observe(el));
  revealAll();
  reduced.addEventListener('change',revealAll);
  document.addEventListener('745:motionchange',revealAll);
  // Keyboard interaction is immediate, even before a delayed reveal has finished.
  document.addEventListener('focusin',event => {
    targets.filter(el=>el===event.target||el.contains(event.target)||event.target.contains(el)).forEach(el=>reveal(el,true));
  });
})();
